// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"fb4d763f","510":"3a70647d","957":"859d7e57"}[chunkId] + ".chunk.js";
};